import React, { useState, useCallback, useEffect } from 'react';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import Divider from '@mui/joy/Divider';

import AdsHomePage from '../../Components/AdsPageWebsite/AdsHomePage';
import PanerAdPage from '../../Components/AdsPageWebsite/PanerAd';
import AdsSectionThree from '../../Components/AdsPageWebsite/adsSectionThree';

//////////////////////// API
import { getAds } from '../../Api/common';



export default function AdsPage() {

    const [currentTab, setCurrentTab] = useState(0)
    const [listAds, setListAds] = useState([]);
    const [listAdsTwo, setListAdsTwo] = useState([]);
    const [listAdsThree, setListAdsThree] = useState([]);

    const currentValue = (event, newValue) => {
        setCurrentTab(newValue)
        if(newValue == 0) {
            getAllAds('1');
        }else if(newValue == 1){
            getAllAds('4');
        }else if(newValue == 2){
            getAllAds('5');
        }
    }


    const getAllAds = useCallback(async (type) => {
        const res = await getAds(type);
        if (res) {
            setListAds(res)
        }
    }, []);

    const getAllAdsSectionTwo = useCallback(async () => {
        const res = await getAds('2');
        if (res) {
            setListAdsTwo(res)
        }
    }, []);

    const getAllAdsSectionThree = useCallback(async () => {
        const res = await getAds('3');
        if (res) {
            setListAdsThree(res)
        }
    }, []);


    useEffect(() => {
        if(currentTab == 0) {
            getAllAds('1');
        }else if(currentTab == 1){
            getAllAds('4');
        }else if(currentTab == 2){
            getAllAds('5');
        }

        getAllAdsSectionTwo();
        getAllAdsSectionThree();
    }, [getAllAds, getAllAdsSectionTwo, getAllAdsSectionThree])

    return (
        <>
            <Tabs
                variant='plain'
                aria-label="Pricing plan"
                defaultValue={0}
                onChange={currentValue}
                sx={{
                    width: '100%',
                    borderRadius: 'sm',
                    // boxShadow: 'sm',
                    overflow: 'auto',
                    backgroundColor: '#FBFBFB',
                }}
            >
                <TabList
                    disableUnderline
                    tabFlex={1}
                    size='lg'
                    sx={{
                        width: '50% !important',
                        [`& .${tabClasses.root}`]: {
                            fontSize: 'sm',
                            fontWeight: 'lg',
                            bgcolor: '#FBFBFB',

                            [`&[aria-selected="true"]`]: {
                                color: 'primary.500',
                                bgcolor: '#F7F9FB',
                            },
                            [`&.${tabClasses.focusVisible}`]: {
                                outlineOffset: '-4px',
                            },
                        },
                    }}
                >
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        الصفحة الرئيسية
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        خدماتنا
                    </Tab>
                    <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                        سومها بالأرقام
                    </Tab>
                </TabList>

                <TabPanel value={0} sx={{ backgroundColor: '#F7F9FB' }}>
                    <AdsHomePage currentTab={currentTab} listAds={listAds}/>
                    <Divider sx={{margin:'50px 0'}}/>
                    <PanerAdPage listAdsTwo={listAdsTwo} getAllAdsSectionTwo={getAllAdsSectionTwo}/>
                    <Divider sx={{margin:'50px 0'}}/>
                    <AdsSectionThree listAdsThree={listAdsThree} getAllAdsSectionThree={getAllAdsSectionThree}/>
                </TabPanel>
                <TabPanel value={1} sx={{ backgroundColor: '#F7F9FB' }}>
                    <AdsHomePage currentTab={currentTab} listAds={listAds}/>
                </TabPanel>
                <TabPanel value={2} sx={{ backgroundColor: '#F7F9FB' }}>
                    <AdsHomePage currentTab={currentTab} listAds={listAds}/>
                </TabPanel>
            </Tabs>
        </>
    )
}